import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'multiplier-1x', 'Multiplier1x', [["path",{"d":"M9 16v-8l-2 2"}],["path",{"d":"M13 16l4 -4"}],["path",{"d":"M17 16l-4 -4"}]]);